import styled from "styled-components"

const Panel = styled.section`
height: 518px;
background-color:#fff;
`

export default Panel
